import http from '../../utils/fetch';
export default {
    baseUrl:"/api/swyl/v1/demo/operationLogs",
    page(query) {
        return http({
            url: this.baseUrl+'/selectPage',
            method: 'post',
            params: query
        });
    }
   
}
